/**
 * Pure helpers for service-agreement PDF export UX (§6).
 * Keeps busy/double-click policy testable without Axios changes.
 */

export function resolveServiceAgreementPdfResult(response) {
  if (isPdfBlob(response?.blob)) {
    return {
      ok: true,
      blob: response.blob,
      filename: response.filename || "serviceavtale.pdf",
      pdfUrl: null,
    };
  }
  const pdfUrl = response?.pdf_url;
  if (typeof pdfUrl === "string" && pdfUrl.trim()) {
    return { ok: true, blob: null, filename: null, pdfUrl: pdfUrl.trim() };
  }
  return { ok: false, blob: null, filename: null, pdfUrl: null };
}

function isPdfBlob(value) {
  if (!value || typeof value !== "object") return false;
  if (typeof Blob !== "undefined") return value instanceof Blob;
  return typeof value.slice === "function";
}

export function serviceAgreementPdfActionLabel({ exporting, t }) {
  if (exporting) {
    return t("service.agreements.actions.pdf_exporting");
  }
  return t("service.agreements.actions.export_pdf");
}
